import { InactiveProfileAvatar, InactiveProfiles } from '@/scenes/Header/components/Sidebar/MenuSidebar.style';
import { useActiveProfile, useTokenState } from '@/store/localStorage/useTokenState';
import { selectActiveProfileAugmented } from '@/store/user/selectors/selectActiveProfileAugmented';
import { selectInactiveProfilesAugmented } from '@/store/user/selectors/selectInactiveProfilesAugmented';
import { doLogoutThunk } from '@/store/user/thunks/doLogoutThunk';
import { setActiveProfileThunk } from '@/store/user/thunks/setActiveProfileThunk';
import { getAvatar } from '@/utils/helpers/profiles';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  BottomMenu,
  ChosenProfile,
  ChosenProfileAvatar,
  ChosenProfileAvatarWrapper,
  StyledMenu,
  UserLinks
} from './styled';
import Tooltip from './Tooltip';
import { useTheme } from '@/features/theme';
import SettingsCogIcon from '@/styles/Icons/SettingsCog';
import { ChatIcon } from '@/styles/Icons/Chat';
import ProfileIcon from '@/styles/Icons/Profile';
import ModerationIcon from '@/styles/Icons/Moderation';
import HelpIcon from '@/styles/Icons/Help';
import WrenchIcon from '@/styles/Icons/Wrench';
import JournalIcon from '@/styles/Icons/Journal';
import LockIcon from '@/styles/Icons/Lock';
import SunIcon from '@/styles/Icons/Sun';
import MoonIcon from '@/styles/Icons/Moon';

export function MenuSidebarBottom() {
  const { mode, toggle } = useTheme();
  const isDark = mode === 'dark';

  return (
    <BottomMenu>
      <li key="theme">
        <a
          onClick={toggle}
          role="button"
          aria-label={isDark ? 'Переключить на светлую тему' : 'Переключить на тёмную тему'}
        >
          {isDark ? <SunIcon /> : <MoonIcon />}
          <span>{isDark ? 'светлая тема' : 'тёмная тема'}</span>
        </a>
      </li>
    </BottomMenu>
  );
}

export function MenuSidebar() {
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [profileInTooltip, setProfileInTooltip] = useState(null);
  const [token, setToken] = useTokenState();
  const dispatch = useDispatch();
  const { activeProfileId } = useActiveProfile();

  const profile = useSelector(state => selectActiveProfileAugmented(state, { activeProfileId }));
  const inactiveProfiles = useSelector(state => selectInactiveProfilesAugmented(state, { activeProfileId }));

  const avatar = getAvatar(profile);

  return (
    <>
      <ChosenProfile>
        <ChosenProfileAvatarWrapper>
          <ChosenProfileAvatar>
            <img src={avatar} alt="" />
          </ChosenProfileAvatar>
          {/* <Tick size={25} /> */}
        </ChosenProfileAvatarWrapper>
        <UserLinks>
          <h4>
            <Link to={`/profile/${profile.id}`} data-testid="sidebar-my-active-profile-link">
              <span>{profile.nickname}</span>
            </Link>
          </h4>

          <h5>
            <Link to={`/blog/${profile.blogSlug}`}>{profile.blogTitle}</Link>
          </h5>
        </UserLinks>
      </ChosenProfile>

      <InactiveProfiles>
        {inactiveProfiles.map(inactiveProfile => (
          <InactiveProfileAvatar
            key={inactiveProfile.nickname}
            onMouseOver={() => {
              setTooltipVisible(true);
              setProfileInTooltip(inactiveProfile);
            }}
            onMouseLeave={() => {
              setTooltipVisible(false);
              setProfileInTooltip(null);
            }}
            onClick={() => {
              dispatch(
                setActiveProfileThunk({
                  profileId: inactiveProfile.id,
                  setToken,
                  token
                })
              );
            }}
          >
            <img src={getAvatar(inactiveProfile)} alt="" />
          </InactiveProfileAvatar>
        ))}
      </InactiveProfiles>

      <Tooltip isVisible={isTooltipVisible} {...profileInTooltip} />

      <StyledMenu>
        <li key="settings">
          <Link to="/settings" data-testid="sidebar-settings-link">
            <span>настройки</span>
          </Link>
        </li>
        {profile.isCommunity && (
          <li key="manageCommunity">
            <Link to="/manage/community" data-testid="sidebar-create-new-profile-link">
              <span>управление сообществом</span>
            </Link>
          </li>
        )}
        <li key="conversations">
          <Link to="/direct" data-testid="sidebar-conversations-link">
            разговоры
          </Link>
        </li>
        <li key="createProfile">
          <Link to="/account/create" data-testid="sidebar-create-new-profile-link">
            <span>создать новый профиль</span>
          </Link>
        </li>
        <br />
        <li key="help">
          <Link to="/help" data-testid="sidebar-help-link">
            <span>ответы на вопросы</span>
          </Link>
        </li>
        <li key="errorlog">
          <Link to="/errorlog" data-testid="sidebar-errorlog-link">
            <span>помощь с багами</span>
          </Link>
        </li>
        <li key="terms">
          <Link to="/terms" data-testid="sidebar-terms-link">
            <span>правила</span>
          </Link>
        </li>
        <br />
        <li key="logout">
          <a onClick={() => dispatch(doLogoutThunk(setToken))} data-testid="sidebar-logout-link" role="button">
            <span>выход</span>
          </a>
        </li>
      </StyledMenu>
    </>
  );
}
